/* src/app/footer/footer.component.css */
.footer_links {
  padding: 15px;
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.footer_links p {
  display: inline;
  padding: 20px;
}
.footer_links a {
  color: #000;
  text-transform: uppercase;
  text-decoration: none;
}
.footer_links a:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=footer.component.css.map */
